<!--产品统计详情-->
<template>
  <div>
    <el-dialog title="导出进度" :visible.sync="exportProgressVisible"
               width="30%" :close-on-click-modal="false" :append-to-body="true"
               :show-close="false">
      <div style="text-align:center;padding:20px;">
        <el-progress :percentage="exportProgress" :stroke-width="20"
                     :text-inside="true"></el-progress>
        <p style="margin-top:10px;color:#909399;font-size:13px;">
          正在获取第 {{ exportCurrentChunk }}/{{ exportTotalChunks }} 批数据...
        </p>
      </div>
    </el-dialog>
    <el-dialog title="产品" :visible.sync="dialogstoreVisible" custom-class="full-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
      <div class="search-content">
        <el-col :span="24" class="toobar">
          <el-col :span="13">
            <el-select v-model="datetype" placeholder="请选择时间类别" style="width: 120px" size="mini">
              <el-option
                :label="'按确认日期'"
                :value="'10'">
              </el-option>
              <el-option
                :label="'按发货日期'"
                :value="'20'">
              </el-option>
            </el-select>
            <el-date-picker size="mini"
                            v-model="searchdatevalue" :clearable="false"
                            type="daterange" :value-format="'yyyy-MM-dd'"
                            align="left" :unlink-panels="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions2"
                            style="width:224px"
            >
            </el-date-picker>
            <el-select v-model="searchjxs" style="width:140px" placeholder="请选择经销商" @change="bindGrid" v-if="jxsdata.length>1" size="mini">
              <el-option
                v-for="item in jxsdata"
                :key="item.serialnum"
                :label="item.dname"
                :value="item.serialnum">
              </el-option>
            </el-select>
            <el-select v-model="puhuo" placeholder="销货单" style="width: 100px" size="mini">
              <el-option label="全部" value="2"></el-option>
              <el-option label="销货单" value=""></el-option>
              <el-option label="铺货单" value="1"></el-option>
            </el-select>
            <el-checkbox v-model="showPackageSize" @change="bindGrid" size="mini">度数/色号</el-checkbox>
          </el-col>
            <span v-if="showPackageSize" style="margin-left:5px;white-space:nowrap;">
                <span>球镜：</span>
                <el-input style="width:65px;" v-model="searchY" size="mini" placeholder="0.00"
                          :disabled="searchM!=''||searchC!=''" @blur="formatDecimal('searchY')"></el-input>
                <span>柱镜：</span>
                <el-input style="width:65px;" v-model="searchX" size="mini" placeholder="0.00"
                          :disabled="searchM!=''||searchC!=''" @blur="formatDecimal('searchX')"></el-input>
                <span style="margin:0 5px;color:#c0c4cc;">|</span>
                <span>型号：</span>
                <el-input style="width:70px;" v-model="searchM" size="mini"
                          :disabled="searchX!=''||searchY!=''"></el-input>
                <span>色号：</span>
                <el-input style="width:70px;" v-model="searchC" size="mini"
                          :disabled="searchX!=''||searchY!=''"></el-input>
            </span>
          <!--el-col :span="24"-->
          <el-col :span="24">
            <el-col :span="13 " style="margin-top: 5px;">
              <el-input style="width:120px;" placeholder="订单号" v-model="erpserial" size="mini"></el-input>
              <CommonTree :treeWidth="250" :treeHeight="200" style="width: 128px;display: inline-block;" :inputSize="'mini'"
                          ref="treeSeed" :defineDataSource="true" @bindData="bindTreeData"
                          @afterBindTree="afterBindTree"
                          :onlyShowGroupType="true"
                          @check="checktree1" :canDelete="false"
                          :searchText="categoryname"
                          :needTopNode="false"
                          placeholder="选择品牌">
              </CommonTree>
              <el-input style="width:120px;height: 40px" placeholder="选择商品" v-model="seedname" clearable size="mini"
                        @click.native="showGoodDetailSel"
                        @clear="clearSeedCode">
              </el-input>
              <CommonTree ref="treeDserial" :treeHeight="180" :searchText="serveuname" @check="changeServer" :inputSize="'mini'"
                          placeholder="请选择业务员" style="width: 128px;display: inline-block;"
                          :isShowCheckBox="false"></CommonTree>
            </el-col>
            <el-col :span="6" style="margin-top: 5px;">
              <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
              <el-button type="warning" v-on:click="excelPort" :disabled="isExporting" size="mini">导出</el-button>
            </el-col>
          </el-col>
        </el-col>

      </div>
      <el-table v-if="dialogstoreVisible"
                  :data="goodsData"
                  :height="eltableheight"
                  size="mini"
                  show-summary :summary-method="getSummaries"
                  stripe
                  border
                  style="width: 100%;">
          <el-table-column
            width="60" fixed
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
          </el-table-column>
          <el-table-column
            prop="erpserial"
            label="订单号"
            align="center" fixed
            header-align="center" width="130">
            <template slot-scope="scope">
                  <span>
                    {{ scope.row.erpserial }}
                  </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="seedname" fixed :show-overflow-tooltip="true"
            label="名称"
            align="left"
            header-align="center"
            width="220">
            <template slot-scope="scope">
              {{ scope.row.seedname }}
            </template>
          </el-table-column>
          <el-table-column
            prop="seedcode"
            label="产品编码"
            align="left"
            header-align="center"
            width="140">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 96%;height:24px;"
                   :title="scope.row.seedcode">{{ scope.row.seedcode }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="categoryname"
            label="品牌"
            align="left"  :show-overflow-tooltip="true"
            header-align="center"
            width="90">
          </el-table-column>
          <el-table-column v-if="showPackageSize"
                           label="球镜/规格"
                           align="right"
                           header-align="center"
                           width="105">
            <template slot-scope="scope">
              {{getPackagesizeY(scope.row.packagesize)}}
            </template>
          </el-table-column>
          <el-table-column v-if="showPackageSize"
                           label="柱镜/色号"
                           align="right"
                           header-align="center"
                           width="105">
            <template slot-scope="scope">
              {{getPackagesizeX(scope.row.packagesize)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalnumber"
            label="数量"
            align="left"
            header-align="center"
            width="70">
          </el-table-column>
          <el-table-column
            prop="saleprice"
            label="销售单价"
            align="right"
            header-align="center"
            width="70">
            <template slot-scope="scope">
              {{(scope.row.salemoney/scope.row.totalnumber)|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="salemoney"
            label="销售金额"
            align="right"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.salemoney|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="discount"
            label="折扣"
            align="right"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.discount|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="pricetax"
            label="实收单价"
            align="right"
            header-align="center"
            width="70">
            <template slot-scope="scope">
              {{(scope.row.totalmoneytax/scope.row.totalnumber)|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="totalmoneytax"
            label="实收金额"
            align="right"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.totalmoneytax|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="rebate"
            label="返利"
            align="right"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              {{scope.row.rebate|numeric(2)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="customerserial"
            label="客户编码"
            align="left" :show-overflow-tooltip="true"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="customername"
            label="客户"
            align="left"
            header-align="center"
            width="200">
            <template slot-scope="scope">
                  <span>
                      <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 96%;height:24px;"
                           :title="scope.row.customername">{{ scope.row.customername }}
                      </div>
                  </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="serveuname"
            label="业务员"
            align="left"
            header-align="center"
            width="100">
          </el-table-column>
          <el-table-column
            prop="paymethod"
            label="支付方式"
            align="left"
            header-align="center"
            width="100">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 96%;height:24px;">
                {{
                scope.row.yfk==0&&scope.row.htje>0?'按合同结算': scope.row.yfk==0&&scope.row.htje==0?"已支付(优惠券)":
                scope.row.paymethod }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="htqd"
            label="支付时间"
            align="center"
            header-align="center"
            width="140">
            <template slot-scope="scope">
                  <span>
                    {{ scope.row.htqd }}
                  </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="confirmeddate"
            label="订单确认"
            align="center"
            header-align="center"
            width="140">
            <template slot-scope="scope">
                  <span>
                    {{ scope.row.confirmeddate }}
                  </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="applybydname"
            label="服务商"
            align="left"
            header-align="center"
            width="200">
            <template slot-scope="scope">
              <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 96%;height:24px;"
                   :title="scope.row.applybydname">{{ scope.row.applybydname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="handleoverdate"
            label="发货日期"
            align="center"
            header-align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column
            label="验光配镜单号"
            align="center"
            header-align="center"
            width="140"
          >
            <template slot-scope="scope">
              {{getPrescriptionNoFromRemark(scope.row.remark)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="remark" :show-overflow-tooltip="true"
            label="备注"
            align="center"
            header-align="center"
            width="140"
          >
            <template slot-scope="scope">
              {{getLiuYan(scope.row.remark)}}
            </template>
          </el-table-column>
          <el-table-column
            prop="statusname"
            label="状态"
            align="left"
            header-align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="parenterpserial"
            label="原订单号"
            align="left"
            header-align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            label="查看" fixed="right"
            align="right"
            header-align="center"
            width="70">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="lookOrder(scope.$index, scope.row)">查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      <div class="foot">
        <Pagination ref="pagination1" @bindgrid="offsetData" :pagination="pagination"></Pagination>
      </div>
      <CstagreementEdit ref="DataDetail" @bindGrid="bindGrid"></CstagreementEdit>
      <CstagreementMachiningEdit ref="machiningDetail"></CstagreementMachiningEdit>
      <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
  </el-dialog>
</div></template>
<script>
  import {productAccountlist} from '@/api/set/jiesuan';
  import {ConvertMoney, pickerShortCuts} from '@/plugin/ordercommon';
  import {independentDept} from '@/api/set/dept';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import CstagreementMachiningEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import {getRechargeList} from '@/api/set/recharge';
  import {getRemarkContent, getPrescriptionNo} from '@/plugin/ordercommon'
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'

  export default {
    name: '',
    data() {
      return {
        puhuo:"",
        serveuname:"",
        goodsData: [],
        serveuguid:"",
        loadexcel:false,
        financeright: false,//是否有权限查看成本价和利润
        showPackageSize: false,
        exportProgressVisible: false,
        exportProgress: 0,
        exportCurrentChunk: 0,
        exportTotalChunks: 0,
        isExporting: false,
        text: {},
        temp: [],
        type: 'sale',
        formLabelWidth: '120px',
        seen: false,
        dialogstoreVisible: false,
        loading: true,
        searchdatevalue: '',
        oldsearchdatevalue:'',
        eltableheight:300,
        tableData: [],
        pickerOptions2: {
          shortcuts: []
        },
        pagination: {
          currentPage: 1,
          pageSize: 50,
          total: 0
        },
        applybydserial: '',
        applybydserials: '',
        customerserial: '',
        datetype: '10',
        searchjxs: '',
        searchtype: '',
        searchstatus: '',
        erpserial: '',
        seedcode: '',
        seedname: '',
        categorycode: '',
        categoryname: '',
        startmoney: '',
        endmoney: '',
        searchY: '',
        searchX: '',
        searchM: '',
        searchC: '',
        totalNums:{},
        jxsdata: [],
        typedata: [{
          value: '',
          text: '全部分类'
        }, {
          value: '10',
          text: '现片'
        }, {
          value: '20',
          text: '定制片'
        }, {
          value: '50',
          text: '加工'
        }],
        statusdata: [{
          value: '',
          text: '全部状态'
        }, {
          value: '1',
          text: '未发货'
        }, {
          value: '-1',
          text: '已发货'
        }]
      }
    },
    methods: {
      checkDateSepar() {
        var value=this.searchdatevalue
        var startDate = new Date(value[0]);
        var endDate = new Date(value[1]);
        var preDate = endDate.getMonth() >= 3 ? new Date(endDate.getFullYear() + '-' + (endDate.getMonth() + 1 - 3) + '-' + endDate.getDate())
          : new Date((endDate.getFullYear() - 1) + '-' + (12 + endDate.getMonth() + 1 - 3) + '-' + endDate.getDate());
        if (startDate <= preDate) {
          this.$message({
            message: '只能导出三个月内的数据！',
            type: 'error'
          })
          return false
        } else {
         return true
        }
      },
      changeServer(guids, names, arr) {
        this.serveuguid = guids;
        this.serveuname = names;
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
      },
      getPackagesizeY(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        return ps.Y?ps.Y:ps.M;
      },
      getPackagesizeX(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);

        return ps.X?ps.X:ps.C;
      },
      async excelPort() {
        if (this.isExporting) return;
        if(!this.checkDateSepar()) return;
        this.isExporting = true;
        try {
          var startDate = new Date(this.searchdatevalue[0]);
          var endDate = new Date(this.searchdatevalue[1]);

          // 按最多7天分块
          var chunks = [];
          var current = new Date(startDate);
          while (current <= endDate) {
            var chunkEnd = new Date(current);
            chunkEnd.setDate(chunkEnd.getDate() + 6);
            if (chunkEnd > endDate) chunkEnd = new Date(endDate);
            chunks.push({
              start: new Date(current),
              end: new Date(chunkEnd)
            });
            current.setDate(current.getDate() + 7);
          }

          this.exportTotalChunks = chunks.length;
          this.exportCurrentChunk = 0;
          this.exportProgress = 0;
          this.exportProgressVisible = true;

          var allData = [];
          var pachagesizeVal = ''
          if (this.showPackageSize) {
            if (this.searchY !== '' || this.searchX !== '') {
              pachagesizeVal = '{"X":"' + this.searchX + '","Y":"' + this.searchY + '"%'
            } else if (this.searchM !== '' || this.searchC !== '') {
              var likeM = this.searchM ? '%' + this.searchM + '%' : '%'
              var likeC = this.searchC ? '%' + this.searchC + '%' : '%'
              pachagesizeVal = '{"M":"' + likeM + '","C":"' + likeC + '"}'
            }
          }

          for (let i = 0; i < chunks.length; i++) {
            this.exportCurrentChunk = i + 1;
            this.exportProgress = Math.round((i / chunks.length) * 100);

            var chunk = chunks[i];
            var bDate = chunk.start.getFullYear() + '-' + (chunk.start.getMonth() + 1) + "-" + chunk.start.getDate();
            var eDate = chunk.end.getFullYear() + '-' + (chunk.end.getMonth() + 1) + "-" + chunk.end.getDate();

            try {
              var response = await productAccountlist({
                datetype: this.datetype,
                begindate: bDate,
                enddate: eDate,
                applybydserial: this.searchjxs,
                categorycode: this.categorycode,
                customerserial: this.customerserial,
                ifsend: this.searchstatus,
                filltemplate: this.searchtype,
                getgroupguids: "1111",
                erpserial: this.erpserial,
                seedcode: this.seedcode,
                startmoney: this.startmoney,
                endmoney: this.endmoney,
                needpackagesize: this.showPackageSize ? 1 : 0,
                serveuguid: this.serveuguid,
                puhuo: this.puhuo,
                pachagesize: pachagesizeVal
              });
              allData = allData.concat(response.data.obj);
            } catch (ex) {
              this.$message({message: '第' + (i + 1) + '批数据获取失败！', type: 'error'});
            }

            await this.$nextTick();
          }

          this.exportProgress = 100;
          this.exportProgressVisible = false;

          // --- 以下为原有导出处理逻辑 ---
          let data = []
          for (let i in allData) {
            data.push(Object.assign({}, allData[i]))
          }

          let header1 = ''
          let column1 = ''
            header1 = ["订单号", "产品名称", "产品编码", "品牌", "数量", "销售单价", "销售金额", "折扣", "实收单价", "实收金额", "返利","客户编码", "客户", "业务员", "支付方式", "支付时间", "订单确认", "服务商", "发货日期", "验光配镜单号", "备注", "状态", "原订单号"]
            column1 = ["erpserial", "seedname", "seedcode", "categoryname", "totalnumber", "saleprice", "salemoney", "discount", "pricetax", "totalmoneytax","rebate", "customerserial", "customername", "serveuname", "paymethod", "htqd", "confirmeddate", "applybydname", "handleoverdate", "prescriptionNo", "remark", "statusname", "parenterpserial"]

          var isJingJia=false
          if(data.length>0&&this.showPackageSize&&data[0]['packagesize'] != undefined && data[0]['packagesize'] != '') {
            if (JSON.parse(data[0]['packagesize']).M) {
              isJingJia=true;
            }
          }

          if (this.showPackageSize) {
            if (isJingJia) {
              header1.splice(3, 0, "型号")
              header1.splice(4, 0, "色号")
            } else {
              header1.splice(3, 0, "球镜")
              header1.splice(4, 0, "柱镜")
            }
            column1.splice(3, 0, "Y")
            column1.splice(4, 0, "X")
          }
          var name = new Date();
          name = (this.seedname || (data.length>0?data[0].seedname:'')) + this.fmtDate(name);
          let heji = {}
          let totalnumber = 0, salemoney = 0, discount = 0, totalmoneytax = 0, costtotalmoney = 0, profit = 0,rebate=0
          for (let i = 0; i < data.length; i++) {
            totalnumber = totalnumber + (data[i]["totalnumber"] || 0)
            salemoney = salemoney + (data[i]["salemoney"] || 0)
            discount = discount + (data[i]["discount"] || 0)
            totalmoneytax = totalmoneytax + (data[i]["totalmoneytax"] || 0)
            costtotalmoney = costtotalmoney + (data[i]["costtotalmoney"] || 0)
            profit = profit + (data[i]["profit"] || 0)
            rebate = rebate + (data[i]["rebate"] || 0)

            data[i]["salemoney"] = (Math.round(data[i]["salemoney"] * 100) / 100).toFixed(2)
            data[i]["discount"] = (Math.round(data[i]["discount"] * 100) / 100).toFixed(2)
            data[i]["totalmoneytax"] = (Math.round(data[i]["totalmoneytax"] * 100) / 100).toFixed(2)
            data[i]["costtotalmoney"] = (Math.round(data[i]["costtotalmoney"] * 1000) / 1000).toFixed(3)
            data[i]["profit"] = (Math.round(data[i]["profit"] * 100) / 100).toFixed(2)

            data[i]['saleprice'] = (Math.round((data[i]['salemoney'] / data[i]['totalnumber']) * 100) / 100).toFixed(2)
            data[i]['pricetax'] = (Math.round((data[i]['totalmoneytax'] / data[i]['totalnumber']) * 100) / 100).toFixed(2)
            data[i]['costprice'] = (Math.round((data[i]['costtotalmoney'] / data[i]['totalnumber']) * 1000) / 1000).toFixed(3)
            var rawRemark = data[i]['remark']
            data[i]['remark'] = this.getLiuYan(rawRemark)
            data[i]['prescriptionNo'] = this.getPrescriptionNoFromRemark(rawRemark)
            if (this.showPackageSize) {
              if (data[i]['packagesize'] != undefined && data[i]['packagesize'] != '') {
                if (isJingJia) {
                  data[i]['Y'] = JSON.parse(data[i]['packagesize']).M
                  data[i]['X'] = JSON.parse(data[i]['packagesize']).C
                } else {
                  data[i]['Y'] = JSON.parse(data[i]['packagesize']).Y
                  data[i]['X'] = JSON.parse(data[i]['packagesize']).X
                }
              } else {
                data[i]['Y'] = ''
                data[i]['X'] = ''
              }
            }
          }
          heji["erpserial"] = "合计"
          heji["totalnumber"] = totalnumber
          heji["salemoney"] = (Math.round(salemoney * 100) / 100).toFixed(2)
          heji["discount"] = (Math.round(discount * 100) / 100).toFixed(2)
          heji["totalmoneytax"] = (Math.round(totalmoneytax * 100) / 100).toFixed(2)
          heji["costtotalmoney"] = (Math.round(costtotalmoney * 1000) / 1000).toFixed(3)
          heji["profit"] = (Math.round(profit * 100) / 100).toFixed(2)
          heji["rebate"] = (Math.round(rebate * 100) / 100).toFixed(2)
          data.push(heji)

          this.$exportExcel(header1, column1, data, name)
        } finally {
          this.isExporting = false;
        }
      },
      fmtDate(obj) {
        var date = new Date(obj);
        var y = 1900 + date.getYear();
        var m = "0" + (date.getMonth() + 1);
        var d = "0" + date.getDate();
        return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          switch (column.property) {
            case 'totalnumber':
              sums.push(this.$numeric(this.totalNums.totalnumber, 0))
              break;
            case 'salemoney':
              sums.push(this.$numeric(this.totalNums.salemoney, 2))
              break;
            case 'discount':
              sums.push(this.$numeric(this.totalNums.discount, 2))
              break;
            case 'totalmoneytax':
              sums.push(this.$numeric(this.totalNums.totalmoneytax, 2))
              break;
            case 'rebate':
              sums.push(this.$numeric(this.totalNums.rebate, 2))
              break;
            default:
              sums.push("")
              break;
          }
        })
        return sums;
      },

      show() {
        this.dialogstoreVisible = true
        this.showPackageSize = false
        this.searchY = ''
        this.searchX = ''
        this.searchM = ''
        this.searchC = ''
      },
      initData(row, time, datetype, independentserial, categorycode, categoryname, customerserial, filltemplate,puhuo) {
        if(puhuo==null)
          puhuo=""
        this.puhuo=puhuo;
        this.searchtype = filltemplate || ""
        this.datetype = datetype
        this.searchdatevalue = time
        this.oldsearchdatevalue = this.searchdatevalue;
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.categorycode = categorycode || ""
        this.searchjxs = independentserial
        this.categoryname = categoryname
        this.customerserial = customerserial || ""
        if (this.searchdatevalue == null || this.searchdatevalue == '') {
          this.$message({
            message: '统计日期范围必须选择！',
            type: 'error'
          })
          return;
        }
        var startDate = this.searchdatevalue[0];
        var endDate = this.searchdatevalue[1];
        this.showPackageSize = false
        this.searchY = ''
        this.searchX = ''
        this.searchM = ''
        this.searchC = ''
        this.bindGrid();

      },
      offsetData() {
        var offset = (this.pagination.currentPage - 1) * this.pagination.pageSize;
        var limit = this.pagination.pageSize;
        this.goodsData = [];
        var hasv = 0;
        while (true) {
          if (offset >= this.pagination.total || hasv >= limit)
            break;
          this.goodsData.push(this.tableData[offset]);
          offset++;
          hasv++;
        }
      },
      bindGrid() {
        this.tableData = [];
        this.goodsData = [];
        if (this.searchdatevalue == null || this.searchdatevalue == '') {

          this.$message({
            message: '统计日期范围必须选择！',
            type: 'error'
          })
          return;
        }
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        this.totalNums = {};
        var pachagesizeVal = ''
        if (this.showPackageSize) {
          if (this.searchY !== '' || this.searchX !== '') {
            pachagesizeVal = '{"X":"' + this.searchX + '","Y":"' + this.searchY + '"%';
            pachagesizeVal=pachagesizeVal.replace('""','"%"');
          } else if (this.searchM !== '' || this.searchC !== '') {
            var likeM = this.searchM ? '%' + this.searchM + '%' : '%'
            var likeC = this.searchC ? '%' + this.searchC + '%' : '%'
            pachagesizeVal = '{"M":"' + likeM + '","C":"' + likeC + '"}'
          }
        }
        productAccountlist({
          datetype: this.datetype,
          begindate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate(),
          enddate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate(),
          applybydserial: this.searchjxs,
          categorycode: this.categorycode,
          customerserial: this.customerserial,
          ifsend: this.searchstatus,
          filltemplate: this.searchtype,
          getgroupguids: "1111",
          erpserial: this.erpserial,
          seedcode: this.seedcode,
          startmoney: this.startmoney,
          endmoney: this.endmoney,
          needpackagesize: this.showPackageSize ? 1 : 0,
          serveuguid: this.serveuguid,
          puhuo: this.puhuo,
          pachagesize: pachagesizeVal
        }).then(request => {
          var th = this.dialogtableHeight(220);
          this.eltableheight = this.eltableheight == th ? (th - 1) : th;
          this.loadexcel = request.data.loadexcel;
          this.tableData = request.data.obj
          this.pagination.total = this.tableData.length;
          var totalNumsarr = {totalnumber: 0, salemoney: 0, discount: 0, totalmoneytax: 0, rebate: 0};
          for (let i in this.tableData) {
            totalNumsarr.totalnumber += parseFloat(this.tableData[i].totalnumber);
            totalNumsarr.salemoney += parseFloat(this.tableData[i].salemoney);
            totalNumsarr.discount += parseFloat(this.tableData[i].discount);
            totalNumsarr.totalmoneytax += parseFloat(this.tableData[i].totalmoneytax);
            totalNumsarr.rebate += parseFloat(this.tableData[i].rebate);
          }
          this.totalNums = totalNumsarr;
          this.offsetData();
        })
      },
      bindTreeData() {//绑定分类树
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType: true, onlyShowEnabledGroupType: true});
        })
      },
      afterBindTree(result) {
      },
      getLiuYan(remark) {
        return getRemarkContent(remark).replace(/<br\/\>/g,"；");
      },

      getPrescriptionNoFromRemark(remark) {
        return getPrescriptionNo(remark);
      },
      formatDecimal(field) {
        var val = this[field]
        if (val === '' || val === undefined || val === null) return
        val = val.toString().replace(/[^\d.-]/g, '')
        var num = parseFloat(val)
        if (isNaN(num)) { this[field] = ''; return }
        this[field] = num.toFixed(2)
      },

      checktree1(guids, names, arr) {
        this.categoryname = names
        this.categorycode = guids;
        this.seedname = ""
        this.seedcode = ""
      },

      lookOrder(index, row) {
        if (row.filltemplate == 50) {
          this.$refs.machiningDetail.initData(row)
          this.$refs.machiningDetail.show()
        } else {
          this.$refs.DataDetail.initData(row)
          this.$refs.DataDetail.show()
        }
      },

    },
    watch: {
      searchY(val) {
        if (val !== '' && val !== undefined && val !== null) {
          this.searchM = ''
          this.searchC = ''
        }
      },
      searchX(val) {
        if (val !== '' && val !== undefined && val !== null) {
          this.searchM = ''
          this.searchC = ''
        }
      },
      searchM(val) {
        if (val !== '' && val !== undefined && val !== null) {
          this.searchX = ''
          this.searchY = ''
        }
      },
      searchC(val) {
        if (val !== '' && val !== undefined && val !== null) {
          this.searchX = ''
          this.searchY = ''
        }
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.searchjxs = this.userInfoModel.independentserial
      this.financeright = this.$checkRight("维护成本价")
      var end = new Date();//当天
      var start = new Date(end.getFullYear(), end.getMonth(), 1);
      this.searchjxs = '';
      this.searchtype = '';
      this.searchstaus = '';
      this.searchdatevalue = [start, end];
      this.oldsearchdatevalue = this.searchdatevalue;
      this.pickerOptions2.shortcuts = pickerShortCuts();
      //获取经销商
      independentDept({}).then(response => {
        if (response.data.obj) {
          this.jxsdata = response.data.obj
          if (this.userInfoModel.independentserial == "") {
            if (this.$checkRight("财务")) {
              this.jxsdata.unshift({serialnum: "all", dname: "全部"})
            } else {//只保留总部的
              this.jxsdata = this.jxsdata.filter(o => {
                return o.serialnum == ""
              })
            }
          }
        }
      }).catch((error) => {
      });

    },
    components: {
      CstagreementEdit,
      CstagreementMachiningEdit,
      JxcgooddetailSel
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/StoreDetailListSeedSee.vue